import { useContext, useState } from 'react';
import { Container } from 'react-bootstrap';
import Card from 'react-bootstrap/esm/Card';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { FaRegCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from 'styled-components';
import { Paths } from '../../Routes';
import AppPropsContext from '../../context/appPropsContext';
import { useLanguage } from '../../hooks/useLanguage';
import StyledButton from '../Buttons/StyledButton';
import { StyledMainCardTitle, StyledProfileCard } from '../Cards/StyledCard';
import { ISelectComboboxOption, SelectCombobox } from '../Combobox/Combobox';
import { CenterDiv, RightDiv } from '../Div/StyledDiv';
const EnrollCodeBox = () => {
    const navigate = useNavigate();

    const { t } = useLanguage();
    const themeContext = useContext(ThemeContext);
    const { apstate } = useContext(AppPropsContext);

    //const screenSize = useScreenResolution();

    const [selectedLocation, setSelectedLocation] = useState<ISelectComboboxOption>();

    // const getMarginRightLeft = () => {
    //     if (screenSize.width > 1700) {
    //         return '50px';
    //     } else if (screenSize.width > 1300) {
    //         return '20px';
    //     } else {
    //         return '10px';
    //     }
    // };

    const getLocationOptions: () => ISelectComboboxOption[] | null = () => {
        if (apstate.anmeldeContexts && apstate.anmeldeContexts.length > 0) {
            return apstate.anmeldeContexts.map((anmeldeContext) => ({
                value: anmeldeContext.code,
                label: anmeldeContext.name,
            }));
        } else {
            return null;
        }
    };

    const handleTerminAnfordernClick = () => {
        navigate(Paths.NEUER_ACCOUNT_WL + '?reason=' + selectedLocation?.value + '&type=NewAccount');
    };

    return (
        <Row style={{ height: '100%' }}>
            <Col style={{ display: 'flex' }}>
                <StyledProfileCard>
                    <Card.Body>
                        <article aria-labelledby="appointment-without-account-heading">
                            <StyledMainCardTitle>
                                {/* TODO: make ^ use h2 (or parametrized hX), while styling as before (right?) */}
                                <h2 id="appointment-without-account-heading">
                                    {t('LOGIN', 'Ihre Terminplanung ohne Account')}
                                </h2>
                            </StyledMainCardTitle>
                            <Container style={{ marginTop: '35px' }}>
                                <CenterDiv>
                                    <FaRegCalendarAlt
                                        size={68}
                                        color={themeContext.icon.passive.color}
                                        role="img"
                                        aria-label={t('LOGIN', 'Kalendergrafik')}
                                    />
                                </CenterDiv>
                                <CenterDiv style={{ marginTop: '20px', marginBottom: '20px' }}>
                                    {/* <Form.Control
                                    as="select"
                                    name="reason"
                                    defaultValue=""
                                    value={anmeldKatSelected}
                                    onChange={(e) => handleSetAnmeldKat(e)}
                                >
                                    <option disabled key="anmeldKatDefault" hidden value="">
                                        {t('LOGIN', 'Standort wählen')}
                                    </option>
                                    {getAnmeldKatOptions()}
                                </Form.Control> */}
                                    <SelectCombobox
                                        aria-label={t('LOGIN', 'Standort wählen')}
                                        aria-describedby="appointment-without-account-heading"
                                        menuPortalTarget={document.querySelector('body')}
                                        options={getLocationOptions()}
                                        placeholder={t('LOGIN', 'Standort wählen')}
                                        isSearchable={true}
                                        onChange={setSelectedLocation}
                                        inputId="anmeld-location-combobox-input"
                                    />
                                </CenterDiv>
                                <RightDiv>
                                    <StyledButton
                                        disabled={!selectedLocation}
                                        variant="primary"
                                        onClick={() => handleTerminAnfordernClick()}
                                    >
                                        {t('LOGIN', 'Neuen Termin anfordern')}
                                    </StyledButton>
                                </RightDiv>
                            </Container>
                        </article>
                    </Card.Body>
                </StyledProfileCard>
            </Col>
        </Row>
    );
};

export default EnrollCodeBox;
